import Mediator from 'mediator-js';

export default class GlobalMediator {
    private static _instance: Mediator;

    static get instance(): Mediator {
        return this._instance != null ? this._instance : this._instance = new Mediator();
    }
}
